import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import Alert from '../../../_shared/components/Alert';
import {
  isPhoneNumberValid,
  phoneNumberToE164
} from '../../../_shared/utils/phoneNumber';
import ROUTES from '../../../components/Routes/constants';
import Trademark from '../../../_shared/components/Trademark';
import TradeInService from '../../../services/TradeInService';
import MixpanelService from '../../../services/MixpanelService';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';

import {
  TiahDetailsContainer,
  TiahDetailsHeading,
  TiahDetailsSubheading,
  TiahDetailsFormContainer,
  StyledContinueButton
} from '../Styles';

import { PhoneNumberLabel, PhoneNumberInput } from './Styles';
import { VerificationStatus } from '../../../_shared/constants/retail';
import Header from '../../../_shared/components/Header';
import TRToast from '../../../_shared/helpers/TRToast';

const TiahMobile = () => {
  const history = useHistory();
  const intl = useIntl();
  const mixpanel = MixpanelService.get();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isError, setIsError] = useState(false);

  const handleContinue = async () => {
    const isValid = isPhoneNumberValid(phoneNumber);
    if (!isValid) {
      setIsError(true);
      mixpanel.track(MixpanelConfig.names.tiahError, {
        error_type: 'invalid phone number'
      });
      TRToast(
        <Alert
          variant="error"
          messages={[<FormattedMessage id="tiah.phone.error" />]}
        />
      );
      return;
    }

    const E164phoneNumber = phoneNumberToE164(phoneNumber);

    TradeInService.updateUserTradeInProps({ phoneNumber: E164phoneNumber });

    const response = await TradeInService.verifyPhoneNumber(E164phoneNumber);

    if (response.status === VerificationStatus.PENDING) {
      history.push(ROUTES.TIAH_MOBILE_VERIFICATION);
      mixpanel.track(MixpanelConfig.names.tiahEnterPhoneNumber, {});
    } else {
      // error handling logic;
      setIsError(true);
      mixpanel.track(MixpanelConfig.names.tiahError, {
        error_type: 'invalid phone number'
      });
      TRToast(
        <Alert
          variant="error"
          messages={[<FormattedMessage id="tiah.phone.error" />]}
        />
      );
    }
  };

  const onChangePhoneNumber = e => {
    const { value } = e.currentTarget;
    const strValue = value.replace(/[^\w\s]/gi, '');
    setPhoneNumber(value);

    if (!value || value.length === 0 || (strValue && strValue.length !== 10)) {
      return;
    }
    // Special masking for phone number input
    const first3 = strValue.substring(0, 3);
    const mid3 = strValue.substring(3, 6);
    const last4 = strValue.substring(6, 10);

    e.currentTarget.value = `${first3}${mid3 ? '-' : ''}${mid3}${
      last4 ? '-' : ''
    }${last4}`;

    if (isError) {
      setIsError(false);
    }
  };

  useEffect(() => {
    const userProps = TradeInService.getUserTradeInProps();

    if (!userProps?.dealerId || !userProps?.dealerDisplayName) {
      TradeInService.removeUserTradeInProps();
      history.push(ROUTES.TIAH);
    }
  });

  return (
    <>
      <Header
        title={intl.formatMessage({ id: 'tiah.phone.title' })}
        testId="tiah-mobile-header"
        onBackClick={() => history.push(ROUTES.TIAH_DEALER_MAP)}
      />
      <TiahDetailsContainer>
        <TiahDetailsHeading>
          {intl.formatMessage({ id: 'tiah.phone.heading' })}
        </TiahDetailsHeading>
        <TiahDetailsSubheading>
          {intl.formatMessage({ id: 'tiah.phone.subheading' })}
        </TiahDetailsSubheading>
        <TiahDetailsFormContainer>
          <PhoneNumberLabel isError={isError}>
            {intl.formatMessage({ id: 'tiah.phone.title' })}
          </PhoneNumberLabel>
          <PhoneNumberInput
            placeholder={intl.formatMessage({ id: 'tiah.phone.placeholder' })}
            onChange={onChangePhoneNumber}
            isError={isError}
            inputMode="tel"
            type="tel"
          />
        </TiahDetailsFormContainer>
        <StyledContinueButton onClick={handleContinue}>
          {intl.formatMessage({ id: 'tiah.continue' })}
        </StyledContinueButton>
      </TiahDetailsContainer>
      <Trademark />
    </>
  );
};

export default TiahMobile;
